import { Attributes, Misc, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";
import RunInterceptionComponent from "../../../../Common/Components/Interception/RunInterceptionComponent";

@NeoModel
export default class ProvisionalTaxReportsSearchCriteria extends ModelBase {
    
  public rawAccountID: string = "";

  @Rules.Required()
  public staticServiceProviderFileGroupingID: number = 0;

  public financialYear: string | undefined = "";

  @Attributes.Date(Misc.TimeZoneFormat.None)
  @Rules.Required("")
  public finYearDate: Date | null = null;

  public clientNumber: string = "";  

  public serviceProviderGroupingName: string ="";
}